import { Outlet } from "react-router-dom";
import { EventHeader } from "widgets";
import { Footer } from "widgets";
import styles from "./EventPageLayout.module.scss";

export const EventPageLayout = () => {
  return (
    <div className={styles.pageContainer}>
      <div className={styles.pageWrapper}>
        <EventHeader />
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};
